import SitesListing from '../../components/SitesListing'
import TopSideBar from '../../components/TopSideBar'

export default function SiteListingPage({ setBlockScreen }: any) {

  return <>
    <TopSideBar currentSection='sites' />

    <SitesListing
      setBlockScreen={setBlockScreen}
    />
  </>
}